import { FC } from 'react';

import { GeoMapList } from 'components/GeoMap/List/GeoMapList';
import { Tabs, TabsContent, TabsList, TabsTrigger } from 'components/ui/tabs';
import { cn } from 'lib/utils';
import { MapForm } from './MapForm';

export const MapPickForm: FC = () => {
  const tabs = [
    {
      id: 1,
      title: "A partir d'une carte GeoJSON",
      content: <MapForm />,
    },
    {
      id: 2,
      title: 'Réutiliser une carte GeoJSON existante',
      content: <GeoMapList />,
    },
  ];
  const defaultTabId = tabs[0]?.id;

  return (
    <div className="py-8">
      <Tabs
        {...(defaultTabId !== undefined
          ? { defaultValue: String(defaultTabId) }
          : {})}
      >
        <TabsList className="flex bg-blue-600 rounded-t-lg p-2">
          {tabs.map((tab) => (
            <TabsTrigger
              key={tab.id}
              value={String(tab.id)}
              className={cn(
                'rounded-t-lg p-4 text-sm font-medium leading-5 text-blue-100 hover:bg-white/10 hover:text-white',
                'ring-blue ring-opacity-60 ring-offset-1 ring-offset-blue-400 focus:outline-none focus:ring-1',
                'data-[state=active]:bg-white data-[state=active]:text-blue-700 data-[state=active]:shadow'
              )}
            >
              {tab.title}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent
            key={tab.id}
            value={String(tab.id)}
            className="rounded-b-lg border border-blue-700"
          >
            <div className="p-5">{tab.content}</div>
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
};
